<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">金币管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 8em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>渠道：</label>
          <el-select v-model="channel" placeholder="Select" style="width: 8em">
            <el-option v-for="item in channelArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <!--          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editGoldPriceDialog(-1)">添加</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="num" label="金币数量" v-if="checkColList.indexOf('金币数量') > -1" />
          <el-table-column property="" label="详情信息" v-if="checkColList.indexOf('详情信息') > -1" width="300">
            <template #default="scope">
              <p>渠道：{{scope.row.channel}}</p>
              <p>productId：{{scope.row.productId}}</p>
              <p>平台：{{ scope.row.platformType == 1?'Android':scope.row.platformType ==2?'ios':scope.row.platformType ===4?'鸿蒙':'' }}</p>
            </template>
          </el-table-column>
          <el-table-column property="oldPrice" label="打折前价格" v-if="checkColList.indexOf('打折前价格') > -1"></el-table-column>
          <el-table-column property="newPrice" label="打折后价格" v-if="checkColList.indexOf('打折后价格') > -1"></el-table-column>
          <el-table-column property="discount" label="折扣" v-if="checkColList.indexOf('折扣') > -1"></el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <p>{{scope.row.state==0?'生效':scope.row.state==1?'下架':'--'}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="金币展示" v-if="checkColList.indexOf('金币展示') > -1">
            <template #default="scope">
              <p>{{scope.row.showType==1?'仅购买页面展示':scope.row.showType==2?'仅弹框展示':scope.row.showType==-1?'全部展示':'--'}}</p>
            </template>
          </el-table-column>
          <el-table-column property="orderNum" label="排列" v-if="checkColList.indexOf('排列') > -1"></el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-button @click="editGoldPriceDialog(scope.$index,scope.row)" type="text">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BtnGroup from '../../components/BtnGroup'
import { getGoldPricePageList, getGoldPriceChannelList } from '../../api/url'
import { getFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import GoldPriceDialog from "./components/GoldPriceDialog";

export default {
  name: "GoldPrice",
  components: { BtnGroup },
  data() {
    return {

      stateArray: [
        { label: '不限', value: -1 },
        { label: '生效', value: 0 },
        { label: '下架', value: 1 }
      ],
      state: 0,

      channelArray: [
        { label: '不限', value: '' },
      ],
      channel: '',

      //刷新组
      colList: ['金币数量', '详情信息', '打折前价格', '打折后价格', '折扣', '状态', '金币展示', '排列', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.searchType = 1;
      this.searchValue = ''
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['channel'] = this.channel;
      param['state'] = this.state;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getGoldPricePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editGoldPriceDialog(idx, row) {
      let _title = '';
      let priceForm = {}
      if (idx > -1) {
        _title = '编辑金币套餐'
        priceForm = Object.assign({}, row);
      }else {
        _title = '添加金币套餐'
      }
      Dialog.open({
        title: _title,
        component: GoldPriceDialog,
        data: {
          priceForm: priceForm,
          ids: idx,
        },
        confirm: (result) => {
          this.getPage()
          // if(idx > -1) {
          //   this.pageDataList[idx]['channel'] = result['channel']
          //   this.pageDataList[idx]['productId'] = result['productId']
          //   this.pageDataList[idx]['orderNum'] = result['orderNum']
          //   this.pageDataList[idx]['num'] = result['num']
          //   this.pageDataList[idx]['oldPrice'] = result['oldPrice']
          //   this.pageDataList[idx]['newPrice'] = result['newPrice']
          //   this.pageDataList[idx]['discount'] = result['discount']
          //   this.pageDataList[idx]['state'] = result['state']
          //   this.pageDataList[idx]['showType'] = result['showType']
          // }else{
          //   this.getPage()
          // }
        }
      })
    },

    getChannelList() {
      let _this = this;
      this.channelArray = [{ label: '不限', value: '' }];
      getFormData(getGoldPriceChannelList, {}).then((data) => {
        let { code, msg } = data;
        if(code == 200) {
         data.data.map(item => {
           let obj = {}
           obj.label = item.channel
           obj.value = item.channel
           _this.channelArray.push(obj)
         })
        } else {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'error'
          });
        }
      })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.getChannelList()
  }
}
</script>

<style scoped>

</style>
